import {SingleEvent} from "shared/core/Events/SingleEvent";

test('Check if subscription with one ref works',()=>{
    let singleEvent=new SingleEvent();
    singleEvent.Subscribe(this,()=>{});

    expect(singleEvent.GetSubscriberByRef(this)).not.toBe(null);

});


test('Check if subscription with multiple ref works',()=>{
    let singleEvent=new SingleEvent();
    singleEvent.Subscribe([this,'Price'],()=>{});

    expect(singleEvent.GetSubscriberByRef(this)).toBe(undefined);
    expect(singleEvent.GetSubscriberByRef([this,'test'])).toBe(undefined);
    expect(singleEvent.GetSubscriberByRef([this,'Price'])).not.toBe(undefined);

});